import { styled, Button } from '@material-ui/core';

export const ButtonNoWrap = styled(Button)({
    '& *': {
        whiteSpace: 'nowrap',
    },
});
